/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BookingCollaboration,
  BookingDecision,
  Hold,
  HoldCreateUpdate,
  HoldMultiDayResult,
  HoldsChallengeBatchRequest,
  HoldsChallengeRequest,
  HoldsConfirmBatchRequest,
  HoldsCreateMultiDayRequest,
  HoldsRespondToChallengeRequest,
  PaginatedHoldListList,
  PatchedHoldCreateUpdate,
} from '../models/index';
import {
    BookingCollaborationFromJSON,
    BookingCollaborationToJSON,
    BookingDecisionFromJSON,
    BookingDecisionToJSON,
    HoldFromJSON,
    HoldToJSON,
    HoldCreateUpdateFromJSON,
    HoldCreateUpdateToJSON,
    HoldMultiDayResultFromJSON,
    HoldMultiDayResultToJSON,
    HoldsChallengeBatchRequestFromJSON,
    HoldsChallengeBatchRequestToJSON,
    HoldsChallengeRequestFromJSON,
    HoldsChallengeRequestToJSON,
    HoldsConfirmBatchRequestFromJSON,
    HoldsConfirmBatchRequestToJSON,
    HoldsCreateMultiDayRequestFromJSON,
    HoldsCreateMultiDayRequestToJSON,
    HoldsRespondToChallengeRequestFromJSON,
    HoldsRespondToChallengeRequestToJSON,
    PaginatedHoldListListFromJSON,
    PaginatedHoldListListToJSON,
    PatchedHoldCreateUpdateFromJSON,
    PatchedHoldCreateUpdateToJSON,
} from '../models/index';

export interface HoldsBookingDecisionRequest {
    id: string;
    bookingDecision: BookingDecision;
}

export interface HoldsChallengeOperationRequest {
    id: string;
    holdsChallengeRequest?: HoldsChallengeRequest;
}

export interface HoldsChallengeBatchOperationRequest {
    holdsChallengeBatchRequest?: HoldsChallengeBatchRequest;
}

export interface HoldsCollaborationRequest {
    id: string;
}

export interface HoldsConfirmRequest {
    id: string;
    hold: Omit<Hold, 'id'|'canManage'|'hostTeam'|'showTeam'|'bookingRevision'|'acceptedAt'|'stageName'|'stageVenueName'|'promoterTeamName'|'showTitle'|'holdPosition'|'challengerTeamName'|'isExpired'|'hasDecisionDeadline'|'timeUntilExpiration'|'timeUntilChallengeDeadline'|'createdAt'|'updatedAt'|'isActive'|'ticketsSold'|'totalRevenue'|'netProfit'>;
}

export interface HoldsConfirmBatchOperationRequest {
    holdsConfirmBatchRequest?: HoldsConfirmBatchRequest;
}

export interface HoldsCreateRequest {
    holdCreateUpdate: Omit<HoldCreateUpdate, 'id'|'canManage'|'hostTeam'|'showTeam'|'bookingRevision'|'acceptedAt'|'createdBy'>;
}

export interface HoldsCreateMultiDayOperationRequest {
    holdsCreateMultiDayRequest: HoldsCreateMultiDayRequest;
}

export interface HoldsDestroyRequest {
    id: string;
}

export interface HoldsListRequest {
    page?: number;
    show?: string;
    team?: number;
}

export interface HoldsPartialUpdateRequest {
    id: string;
    patchedHoldCreateUpdate?: Omit<PatchedHoldCreateUpdate, 'id'|'canManage'|'hostTeam'|'showTeam'|'bookingRevision'|'acceptedAt'|'createdBy'>;
}

export interface HoldsReleaseRequest {
    id: string;
    hold: Omit<Hold, 'id'|'canManage'|'hostTeam'|'showTeam'|'bookingRevision'|'acceptedAt'|'stageName'|'stageVenueName'|'promoterTeamName'|'showTitle'|'holdPosition'|'challengerTeamName'|'isExpired'|'hasDecisionDeadline'|'timeUntilExpiration'|'timeUntilChallengeDeadline'|'createdAt'|'updatedAt'|'isActive'|'ticketsSold'|'totalRevenue'|'netProfit'>;
}

export interface HoldsRespondToChallengeOperationRequest {
    id: string;
    holdsRespondToChallengeRequest?: HoldsRespondToChallengeRequest;
}

export interface HoldsRetrieveRequest {
    id: string;
}

export interface HoldsUpdateRequest {
    id: string;
    holdCreateUpdate: Omit<HoldCreateUpdate, 'id'|'canManage'|'hostTeam'|'showTeam'|'bookingRevision'|'acceptedAt'|'createdBy'>;
}

/**
 * 
 */
export class HoldsApi extends runtime.BaseAPI {

    /**
     * ViewSet for Hold model with team-scoped access.  Privacy Model: - Venue teams (team_type=\'venue\') see all holds on their stages (they own the venue) - Promoter teams (team_type=\'promoter\', \'venue\', \'performer\') only see their own holds - Challenge endpoint bypasses filtering (promoters can challenge by hold ID without seeing details) - This ensures promoters only know position numbers, not who/what they\'re competing against  Promoter Types (all can create holds): - Independent Promoter teams (team_type=\'promoter\') - only promote shows - Venue teams (team_type=\'venue\') - can promote their own shows (venue-promoted) - Performer teams (team_type=\'performer\') - can self-promote (self-promoted shows)
     */
    async holdsBookingDecisionRaw(requestParameters: HoldsBookingDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingCollaboration>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsBookingDecision().'
            );
        }

        if (requestParameters['bookingDecision'] == null) {
            throw new runtime.RequiredError(
                'bookingDecision',
                'Required parameter "bookingDecision" was null or undefined when calling holdsBookingDecision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/booking-decision/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingDecisionToJSON(requestParameters['bookingDecision']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingCollaborationFromJSON(jsonValue));
    }

    /**
     * ViewSet for Hold model with team-scoped access.  Privacy Model: - Venue teams (team_type=\'venue\') see all holds on their stages (they own the venue) - Promoter teams (team_type=\'promoter\', \'venue\', \'performer\') only see their own holds - Challenge endpoint bypasses filtering (promoters can challenge by hold ID without seeing details) - This ensures promoters only know position numbers, not who/what they\'re competing against  Promoter Types (all can create holds): - Independent Promoter teams (team_type=\'promoter\') - only promote shows - Venue teams (team_type=\'venue\') - can promote their own shows (venue-promoted) - Performer teams (team_type=\'performer\') - can self-promote (self-promoted shows)
     */
    async holdsBookingDecision(requestParameters: HoldsBookingDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingCollaboration> {
        const response = await this.holdsBookingDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get holds within a date range for calendar visualization
     * Get holds for calendar view
     */
    async holdsCalendarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/calendar/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Get holds within a date range for calendar visualization
     * Get holds for calendar view
     */
    async holdsCalendar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsCalendarRaw(initOverrides);
        return await response.value();
    }

    /**
     * Initiate a challenge on this hold with a deadline
     * Challenge a hold
     */
    async holdsChallengeRaw(requestParameters: HoldsChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/challenge/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldsChallengeRequestToJSON(requestParameters['holdsChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Initiate a challenge on this hold with a deadline
     * Challenge a hold
     */
    async holdsChallenge(requestParameters: HoldsChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate challenge cascade for multiple holds at once. Each hold must be 2nd position or higher.
     * Challenge multiple holds (batch)
     */
    async holdsChallengeBatchRaw(requestParameters: HoldsChallengeBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/challenge/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldsChallengeBatchRequestToJSON(requestParameters['holdsChallengeBatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Initiate challenge cascade for multiple holds at once. Each hold must be 2nd position or higher.
     * Challenge multiple holds (batch)
     */
    async holdsChallengeBatch(requestParameters: HoldsChallengeBatchOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsChallengeBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all holds where the user\'s team is being challenged (challenged status with response deadline)
     * Get holds challenged against user
     */
    async holdsChallengedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/challenged/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Get all holds where the user\'s team is being challenged (challenged status with response deadline)
     * Get holds challenged against user
     */
    async holdsChallenged(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsChallengedRaw(initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Hold model with team-scoped access.  Privacy Model: - Venue teams (team_type=\'venue\') see all holds on their stages (they own the venue) - Promoter teams (team_type=\'promoter\', \'venue\', \'performer\') only see their own holds - Challenge endpoint bypasses filtering (promoters can challenge by hold ID without seeing details) - This ensures promoters only know position numbers, not who/what they\'re competing against  Promoter Types (all can create holds): - Independent Promoter teams (team_type=\'promoter\') - only promote shows - Venue teams (team_type=\'venue\') - can promote their own shows (venue-promoted) - Performer teams (team_type=\'performer\') - can self-promote (self-promoted shows)
     */
    async holdsCollaborationRaw(requestParameters: HoldsCollaborationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingCollaboration>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsCollaboration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/collaboration/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingCollaborationFromJSON(jsonValue));
    }

    /**
     * ViewSet for Hold model with team-scoped access.  Privacy Model: - Venue teams (team_type=\'venue\') see all holds on their stages (they own the venue) - Promoter teams (team_type=\'promoter\', \'venue\', \'performer\') only see their own holds - Challenge endpoint bypasses filtering (promoters can challenge by hold ID without seeing details) - This ensures promoters only know position numbers, not who/what they\'re competing against  Promoter Types (all can create holds): - Independent Promoter teams (team_type=\'promoter\') - only promote shows - Venue teams (team_type=\'venue\') - can promote their own shows (venue-promoted) - Performer teams (team_type=\'performer\') - can self-promote (self-promoted shows)
     */
    async holdsCollaboration(requestParameters: HoldsCollaborationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingCollaboration> {
        const response = await this.holdsCollaborationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm this hold and convert it to a confirmed show
     * Confirm a hold
     */
    async holdsConfirmRaw(requestParameters: HoldsConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsConfirm().'
            );
        }

        if (requestParameters['hold'] == null) {
            throw new runtime.RequiredError(
                'hold',
                'Required parameter "hold" was null or undefined when calling holdsConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/confirm/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldToJSON(requestParameters['hold']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Confirm this hold and convert it to a confirmed show
     * Confirm a hold
     */
    async holdsConfirm(requestParameters: HoldsConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm multiple selected holds at once.
     * Confirm multiple holds (batch)
     */
    async holdsConfirmBatchRaw(requestParameters: HoldsConfirmBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/confirm/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldsConfirmBatchRequestToJSON(requestParameters['holdsConfirmBatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Confirm multiple selected holds at once.
     * Confirm multiple holds (batch)
     */
    async holdsConfirmBatch(requestParameters: HoldsConfirmBatchOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsConfirmBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new hold with automatic position calculation
     * Create hold
     */
    async holdsCreateRaw(requestParameters: HoldsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HoldCreateUpdate>> {
        if (requestParameters['holdCreateUpdate'] == null) {
            throw new runtime.RequiredError(
                'holdCreateUpdate',
                'Required parameter "holdCreateUpdate" was null or undefined when calling holdsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldCreateUpdateToJSON(requestParameters['holdCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Create a new hold with automatic position calculation
     * Create hold
     */
    async holdsCreate(requestParameters: HoldsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HoldCreateUpdate> {
        const response = await this.holdsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create holds with authoritative per-date results, including standby interest on confirmed dates.
     * Create multi-day hold
     */
    async holdsCreateMultiDayRaw(requestParameters: HoldsCreateMultiDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HoldMultiDayResult>> {
        if (requestParameters['holdsCreateMultiDayRequest'] == null) {
            throw new runtime.RequiredError(
                'holdsCreateMultiDayRequest',
                'Required parameter "holdsCreateMultiDayRequest" was null or undefined when calling holdsCreateMultiDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/multi_day/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldsCreateMultiDayRequestToJSON(requestParameters['holdsCreateMultiDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldMultiDayResultFromJSON(jsonValue));
    }

    /**
     * Create holds with authoritative per-date results, including standby interest on confirmed dates.
     * Create multi-day hold
     */
    async holdsCreateMultiDay(requestParameters: HoldsCreateMultiDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HoldMultiDayResult> {
        const response = await this.holdsCreateMultiDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a hold
     * Delete hold
     */
    async holdsDestroyRaw(requestParameters: HoldsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a hold
     * Delete hold
     */
    async holdsDestroy(requestParameters: HoldsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.holdsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get all holds that have expired but not yet marked as such
     * Get expired holds
     */
    async holdsExpiredRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/expired/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Get all holds that have expired but not yet marked as such
     * Get expired holds
     */
    async holdsExpired(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsExpiredRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get holds for the active team
     * List holds
     */
    async holdsListRaw(requestParameters: HoldsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedHoldListList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['show'] != null) {
            queryParameters['show'] = requestParameters['show'];
        }

        if (requestParameters['team'] != null) {
            queryParameters['team'] = requestParameters['team'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedHoldListListFromJSON(jsonValue));
    }

    /**
     * Get holds for the active team
     * List holds
     */
    async holdsList(requestParameters: HoldsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedHoldListList> {
        const response = await this.holdsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Partially update an existing hold
     * Partially update hold
     */
    async holdsPartialUpdateRaw(requestParameters: HoldsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HoldCreateUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedHoldCreateUpdateToJSON(requestParameters['patchedHoldCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Partially update an existing hold
     * Partially update hold
     */
    async holdsPartialUpdate(requestParameters: HoldsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HoldCreateUpdate> {
        const response = await this.holdsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Release this hold and reorder remaining holds
     * Release a hold
     */
    async holdsReleaseRaw(requestParameters: HoldsReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsRelease().'
            );
        }

        if (requestParameters['hold'] == null) {
            throw new runtime.RequiredError(
                'hold',
                'Required parameter "hold" was null or undefined when calling holdsRelease().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/release/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldToJSON(requestParameters['hold']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Release this hold and reorder remaining holds
     * Release a hold
     */
    async holdsRelease(requestParameters: HoldsReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * When challenged, respond by confirming (keeping hold) or releasing (giving up hold). If confirmed, challenger loses. If released, challenge cascades to next higher hold.
     * Respond to challenge (Confirm or Release)
     */
    async holdsRespondToChallengeRaw(requestParameters: HoldsRespondToChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsRespondToChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/respond-to-challenge/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldsRespondToChallengeRequestToJSON(requestParameters['holdsRespondToChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * When challenged, respond by confirming (keeping hold) or releasing (giving up hold). If confirmed, challenger loses. If released, challenge cascades to next higher hold.
     * Respond to challenge (Confirm or Release)
     */
    async holdsRespondToChallenge(requestParameters: HoldsRespondToChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsRespondToChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a hold
     * Get hold details
     */
    async holdsRetrieveRaw(requestParameters: HoldsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Get detailed information about a hold
     * Get hold details
     */
    async holdsRetrieve(requestParameters: HoldsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about holds for the user\'s teams
     * Get hold statistics
     */
    async holdsStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/statistics/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldFromJSON(jsonValue));
    }

    /**
     * Get statistics about holds for the user\'s teams
     * Get hold statistics
     */
    async holdsStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hold> {
        const response = await this.holdsStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an existing hold
     * Update hold
     */
    async holdsUpdateRaw(requestParameters: HoldsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HoldCreateUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling holdsUpdate().'
            );
        }

        if (requestParameters['holdCreateUpdate'] == null) {
            throw new runtime.RequiredError(
                'holdCreateUpdate',
                'Required parameter "holdCreateUpdate" was null or undefined when calling holdsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/bookings/holds/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HoldCreateUpdateToJSON(requestParameters['holdCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Update an existing hold
     * Update hold
     */
    async holdsUpdate(requestParameters: HoldsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HoldCreateUpdate> {
        const response = await this.holdsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
